import styled from "styled-components";
import { AuthInput } from "../Auth.styled";

export const SetWithdrawalPinContainer = styled.div`
  margin-block: 30px;
  display: flex;
  flex-direction: column;
`;

export const SetWithdrawalPinInput = styled(AuthInput)``;

export const SetWithdrawalPinButton = styled.button`
  width: 50%;
  height: 50px;
  margin-block-end: 10px;
  margin-inline: auto;
  cursor: pointer;
  border-radius: 10px;
`;

export const SetWithdrawalPinCard = styled.form`
  margin-top: 60px;
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.primary};
  margin-inline: 15px;
  background: #202020;
  padding: 30px;
  border: 1px solid #9965f2;
  border-radius: 10px;
`;
